import React, { useState, useEffect } from 'react';
import { Link, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaBox, FaShoppingCart, FaChartBar, FaSignOutAlt, FaBars, FaUserCircle, FaKey, FaIdBadge, FaUsers, FaUserTie } from 'react-icons/fa';
import './Layout.css';

const Layout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (sidebarOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [sidebarOpen]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const isSalesPage = location.pathname === '/sales';

  return (
    <div className="layout-container">
      <button
        className="btn btn-dark d-md-none sidebar-toggle-btn"
        onClick={handleToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <FaBars />
      </button>

      <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={closeSidebar}></div>
      
      <div className={`sidebar-container bg-dark text-white ${sidebarOpen ? 'open' : ''}`}>
        <div className="p-3 d-flex flex-column h-100">
          <h4 className="text-center mb-4">Comercial App</h4>
          <div style={{marginBottom: '0.2rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
            {user?.name && (
              <div className="fw-bold" style={{marginBottom: '2px', fontSize: '1.05rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
                <FaUserCircle style={{ fontSize: '1.1em', marginRight: 2, opacity: 0.85 }} />
                {user.name}
              </div>
            )}
            <span className={`badge ${user?.role === 'administrador' ? 'bg-primary' : user?.role === 'supervisor' ? 'bg-warning text-dark' : user?.role === 'backoffice' ? 'bg-info' : 'bg-secondary'}`} style={{fontSize: '0.91rem', padding: '2px 8px', lineHeight: 1, display: 'flex', alignItems: 'center', gap: '3px'}}>
              {user?.role === 'administrador'
                ? <FaKey style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                : user?.role === 'supervisor'
                  ? <FaKey style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                  : user?.role === 'backoffice'
                    ? <FaIdBadge style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />
                    : <FaIdBadge style={{ fontSize: '1em', marginRight: 2, opacity: 0.85 }} />}
              {user?.role === 'administrador' ? 'Administrador' : user?.role === 'supervisor' ? 'Supervisor' : user?.role === 'backoffice' ? 'Backoffice' : 'Vendedor'}
            </span>
          </div>
          <hr />
          <nav className="nav flex-column flex-grow-1">
            <Link to="/dashboard" className={`nav-link text-white${location.pathname === '/dashboard' ? ' active' : ''}`} onClick={closeSidebar}>
              <FaChartBar className="me-2" /> Dashboard
            </Link>
            <Link to="/sales" className={`nav-link text-white${location.pathname === '/sales' ? ' active' : ''}`} onClick={closeSidebar}>
              <FaShoppingCart className="me-2" /> Ventas
            </Link>
            {user?.role === 'administrador' && (
              <Link to="/teams" className={`nav-link text-white${location.pathname === '/teams' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaUsers className="me-2" /> Áreas
              </Link>
            )}
            {user?.role === 'administrador' && (
              <Link to="/sellers" className={`nav-link text-white${location.pathname === '/sellers' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaUserTie className="me-2" /> Vendedores
              </Link>
            )}
            {user?.role === 'administrador' && (
              <Link to="/users" className={`nav-link text-white${location.pathname === '/users' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaUserTie className="me-2" /> Usuarios
              </Link>
            )}
            {user?.role === 'administrador' && (
              <Link to="/segments" className={`nav-link text-white${location.pathname === '/segments' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaUsers className="me-2" /> Segmentos
              </Link>
            )}
            {(user?.role === 'administrador' || user?.role === 'supervisor' || user?.role === 'backoffice') && (
              <Link to="/clients" className={`nav-link text-white${location.pathname === '/clients' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaIdBadge className="me-2" /> Clientes
              </Link>
            )}
            <Link to="/catalog" className={`nav-link text-white${location.pathname === '/catalog' ? ' active' : ''}`} onClick={closeSidebar}>
              <FaBox className="me-2" /> Catálogo
            </Link>
            {(user?.role === 'administrador' || user?.role === 'supervisor' || user?.role === 'backoffice') && (
              <Link to="/reports" className={`nav-link text-white${location.pathname === '/reports' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaChartBar className="me-2" /> Reportes
              </Link>
            )}
            {(user?.role === 'administrador' || user?.role === 'supervisor' || user?.role === 'backoffice') && (
              <Link to="/advance-general" className={`nav-link text-white${location.pathname === '/advance-general' ? ' active' : ''}`} onClick={closeSidebar}>
                <FaBars className="me-2" /> Avance General
              </Link>
            )}
          </nav>
          <button
            onClick={handleLogout}
            className="nav-link text-white border-0 bg-transparent mt-auto text-start"
            style={{ cursor: 'pointer' }}
          >
            <FaSignOutAlt className="me-2" /> Cerrar Sesión
          </button>
        </div>
      </div>
      
      <div className={`main-content-area ${isSalesPage ? '' : 'less-padding-top'}`}>
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;